import { HlaAttributeName } from "./HlaAttribute";
import { HlaWay } from "../../hla/models/HlaWay";
import { HlaLane } from "../../hla/models/HlaLane";

export const getHlaAttributeValueForColoring = (
  attributeName: HlaAttributeName,
  way: HlaWay,
  lane: HlaLane,
) => {
  if ((way as any)[attributeName] !== undefined) {
    return (way as any)[attributeName];
  }
  if ((lane as any)[attributeName] !== undefined) {
    return (lane as any)[attributeName];
  }

  // at this point, the attribute must be an adjacentFeature
  if (attributeName === HlaAttributeName.NumberOfLanes) {
    return (
      lane.adjacentFeaturesLeft.numberOfLanes ||
      lane.adjacentFeaturesRight.numberOfLanes
    );
  }

  return (
    (lane.adjacentFeaturesLeft as any)[attributeName] ||
    (lane.adjacentFeaturesRight as any)[attributeName]
  );
};

export const coloringSteps: Partial<Record<HlaAttributeName, number[]>> = {
  [HlaAttributeName.AverageDailyTraffic]: [
    0, 500, 1000, 2500, 5000, 10000, 20000,
  ],
  [HlaAttributeName.AverageRoadSpeed]: [0, 30, 50, 70, 80, 90],
};
